import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [caricamento, setCaricamento] = useState(false);
  
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    setCaricamento(true);

    try {
      const utente = await login(username, password);
      
      // Controlla se è un cliente al primo accesso
      if (utente.ruolo === 'UTENTE' && utente.titolare && !utente.titolare.primo_accesso_completato) {
        navigate('/primo-accesso');
        return;
      }
      
      // Reindirizza in base al ruolo
      switch (utente.ruolo) {
        case 'ADMIN':
          navigate('/admin/dashboard');
          break;
        case 'AUTISTA':
          navigate('/autista/dashboard');
          break;
        case 'UTENTE':
          navigate('/utente/dashboard');
          break;
        default:
          navigate('/');
      }
    } catch (error) {
      console.error('Errore login:', error);
      const data = error.response?.data;
      let errorMsg = 'Credenziali non valide';
      
      if (data) {
        if (data.non_field_errors && data.non_field_errors.length > 0) {
          errorMsg = data.non_field_errors[0];
        } else if (data.detail) {
          errorMsg = data.detail;
        } else if (data.message) {
          errorMsg = data.message;
        } else if (data.username) {
          errorMsg = Array.isArray(data.username) ? data.username[0] : data.username;
        } else if (data.password) {
          errorMsg = Array.isArray(data.password) ? data.password[0] : data.password;
        }
      }
      
      setErrore(errorMsg);
    } finally {
      setCaricamento(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src="/logo.png" alt="Casella Logo" className="login-logo" />
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {errore && <div className="errore-messaggio">{errore}</div>}
          
          <div className="form-group">
            <label htmlFor="username">Email o Telefono</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={caricamento}
              autoFocus
              placeholder="Email o 3331234567"
            />
            <p className="text-xs text-gray-500 mt-1">
              Per il telefono inserisci solo il numero (es. 3331234567)
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={caricamento}
            />
          </div>

          <button type="submit" disabled={caricamento} className="login-button">
            {caricamento ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>
      </div>
      
      <div className="powered-by-footer">
        Powered by <a href="https://neoflux.it" target="_blank" rel="noopener noreferrer"><span>NEOFLUX</span></a>
      </div>
    </div>
  );
};

export default Login;

